<template>
  <transition name="transition-fade" v-if="visible">
    <div class="ds-message-box__wrapper">
      <div :class="['ds-message-box', options.type]">
        <div :class="['ds-message-box__icon', options.showIconColored ? 'colored' : '']" v-if="options.showIcon">
          <svg-icon :icon-class="'ds-message-icon-' + options.type"></svg-icon>
        </div>
        <div class="ds-message-box__title" v-if="options.title">{{options.title}}</div>
        <template v-if="options.message">
          <div class="ds-message-box__message" v-if="options.dangerouslyUseHTMLString" v-html="options.message"></div>
          <div class="ds-message-box__message" v-else>{{options.message}}</div>
        </template>
        <div class="ds-message-box__btns" :style="{ 'justify-content': options.showConfirmButton && options.showCancelButton ? 'space-between' : 'center' }" v-if="options.showConfirmButton || options.showCancelButton">
          <button v-if="options.showCancelButton" type="button" class="ds-button" @click="fnCancel">
            <span>{{options.cancelButtonText}}</span>
          </button>
          <button v-if="options.showConfirmButton" type="button" class="ds-button msgbox-primary" @click="fnConfirm">
            <span>{{options.confirmButtonText}}</span>
          </button>
        </div>
      </div>
      <div class="ds-message-box__close" v-if="options.showClose" @click="Close">
        <svg-icon icon-class="close"></svg-icon>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "MessageBox",
  data() {
    return {
      options: {
        type: "info", //消息框類型（success，info，warning，error，question）
        showIcon: true, //是否展示图标
        showIconColored: true, //是否展示图标颜色
        title: "", //标题
        message: "", //消息内容
        dangerouslyUseHTMLString: false, //是否使用html
        showCancelButton: true, //是否展示取消按钮（若取消和确认按钮都不展示，则用户无法主动关闭弹框）
        cancelButtonText: "取消", //取消按钮文本内容
        showConfirmButton: true, //是否展示确认按钮（若取消和确认按钮都不展示，则用户无法主动关闭弹框）
        confirmButtonText: "確認", //确认按钮文本内容
        showClose: false, //是否展示关闭按钮图标
        callback: null, //关闭后的回调（返回action参数：action 的值为'confirm', 'cancel', 'close'，confirm：用户确认，cancel：用户取消，close：直接关闭/系统关闭）
      },
      visible: false,

      messageType: {
        info: "info",
        success: "success",
        warning: "warning",
        error: "error",
        question: "question",
      },
      actionType: {
        confirm: "confirm",
        cancel: "cancel",
        close: "close",
      },
    };
  },
  mounted() {},
  methods: {
    fnConfirm() {
      this.visible = false;
      if (this.options.callback) {
        this.options.callback(this.actionType.confirm);
      }
    },
    fnCancel() {
      this.visible = false;
      if (this.options.callback) {
        this.options.callback(this.actionType.cancel);
      }
    },
    fnExtendOptions(options) {
      this.options = this.$options.data.call(this).options;
      this.options = Object.assign(this.options, options || {});
    },
    fnSuccess(options) {
      options.type = this.messageType.success;
      this.fnExtendOptions(options);
      this.visible = true;
      return this;
    },
    fnInfo(options) {
      options.type = this.messageType.info;
      this.fnExtendOptions(options);
      this.visible = true;
      return this;
    },
    fnWarning(options) {
      options.type = this.messageType.warning;
      this.fnExtendOptions(options);
      this.visible = true;
      return this;
    },
    fnError(options) {
      options.type = this.messageType.error;
      this.fnExtendOptions(options);
      this.visible = true;
      return this;
    },
    fnQuestion(options) {
      options.type = this.messageType.question;
      this.fnExtendOptions(options);
      this.visible = true;
      return this;
    },
    Close() {
      this.visible = false;
      if (this.options.callback) {
        this.options.callback(this.actionType.close);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ds-message-box__wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 191;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .ds-message-box {
    user-select: none;
    background-color: #ffffff;
    box-sizing: border-box;
    padding: 30px 25px;
    position: relative;
    z-index: 2;
    width: 350px;
    min-height: 85px;
    border-radius: 4px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .ds-message-box__icon {
      font-size: 48px;
      margin-bottom: 10px;
      color: #1e232c;
    }
    .ds-message-box__title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 10px;
      text-align: center;
      color: #1e232c;
    }
    .ds-message-box__message {
      font-size: 14px;
      margin-bottom: 12px;
      text-align: center;
      color: #939393;
      line-height: 1.5;

      width: 100%;
      max-height: 300px;
      overflow-wrap: break-word;
      overflow-y: auto;
    }
    .ds-message-box__btns {
      width: 100%;
      margin-top: 8px;
      display: flex;
      .ds-button {
        width: 48%;
        padding: 10px 6px;
        font-size: 14px;
      }
      .ds-button.msgbox-primary {
        color: #fff;
        background-color: #006eff;
        border-color: #006eff;
      }

      .ds-button.msgbox-primary:active {
        background-color: #0058cb;
        border-color: #0058cb;
        color: #fff;
      }
    }
  }
  .ds-message-box.info {
    .ds-message-box__icon.colored {
      // color: $infoColor;
      color: #1e232c;
    }
  }
  .ds-message-box.success {
    .ds-message-box__icon.colored {
      color: #07c160;
    }
  }
  .ds-message-box.warning {
    .ds-message-box__icon.colored {
      color: #faad14;
    }
  }
  .ds-message-box.error {
    .ds-message-box__icon.colored {
      color: #ff4d4f;
    }
  }
  .ds-message-box.question {
    .ds-message-box__icon.colored {
      // color: $primaryColor;
      color: #1890ff;
    }
  }
  .ds-message-box__close {
    height: 32px;
    width: 32px;
    border-radius: 100%;
    position: relative;
    z-index: 2;
    margin-top: 20px;
    box-sizing: border-box;
    border: 2px solid #9c9c9c;
    color: #d4d4d4;
    font-size: 13px;
    background-color: rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.ds-message-box__wrapper::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

/* >= 801 視爲稍大點的平板或電腦屏幕（自定） */
@media (min-width: 501px) {
  .ds-message-box__wrapper {
    .ds-message-box {
      padding: 30px 25px;
      width: 420px;
      min-height: 95px;
      border-radius: 4px;
      .ds-message-box__icon {
        font-size: 48px;
        margin-bottom: 10px;
      }
      .ds-message-box__title {
        font-size: 16px;
        margin-bottom: 10px;
      }
      .ds-message-box__message {
        font-size: 14px;
        margin-bottom: 12px;
        max-height: 300px;
      }
      .ds-message-box__btns {
        width: 100%;
        margin-top: 8px;
        .ds-button {
          width: 48%;
          padding: 10px 6px;
          font-size: 14px;
          border-radius: 5px;
        }
      }
    }
    .ds-message-box__close {
      height: 32px;
      width: 32px;
      border-radius: 100%;
      margin-top: 20px;
      border: 2px solid #9c9c9c;
      font-size: 13px;
    }
  }
}
</style>
